export enum InputTheme {
  DARK = 'dark',
  LIGHT = 'light',
  FLAT_GRAY = 'flatGray',
  ITALIC_WHITE = 'italicWhite',
  WHITE_WITH_BORDER = 'whiteWithBorder',
  SECTION_BUTTON = 'sectionButton',
}

export enum InputType {
  TEXT = 'text',
  EMAIL = 'email',
  NUMBER = 'number',
  PASSWORD = 'password',
  SEARCH = 'search',
}
export enum InputSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  EXTRA_SMALL = 'EXTRA_SMALL',
}

export { InputSize as IconSize };

export enum InputShape {
  SQUARE = 'SQUARE',
  ROUNDED = 'ROUNDED',
  ROUNDED_MEDIUM = 'ROUNDED_MEDIUM',
  CIRCLE = 'CIRCLE',
}

export type AsyncChangeHandler<T> = (newValue: T, dropdownName: string, selected: T) => Promise<void>;
export type InputValue = number | string | undefined;
export type InputNumberBlurHandler = (value: InputValue) => void;
export type InputNumberChangeHandler = (value: InputValue) => void;
export type InputChangeHandler = (value: InputValue, name?: string) => void;
export type InputBlurHandler = (value: InputValue, name?: string) => void;
